<template>
  <v-container>
    <div>
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}">
          </vc-date-picker>
        </v-col>

        <v-col cols="12" sm="2" justify="end">
          <v-btn color="primary" dark @click="getData">{{ $t('common.search') }}</v-btn>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="createManufacture">{{ $t('common.create_manufacture_request') }}</v-btn>

            <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="date" class="elevation-1"
                  hide-default-footer :page.sync="page" :loading="loading" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event" :item-class="this.$statusSale">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="2">
              <span>Tổng số: <span class="summaryFont"> {{ totalManufactureRequest }} </span> </span>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectReadStatus" :items="readStatus" item-text="title" outlined :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2" v-if="!isAdmin && userCategory > 1">
              <v-autocomplete v-model="selectJobFilter" :items="jobFilters" item-text="title" dense return-object
                              outlined></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="5">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.code`]="{ item }">
        <span class="text-no-wrap">{{ item.code }}</span>
      </template>

      <template v-slot:[`item.designRequest.code`]="{ item }">
        <span class="text-no-wrap">{{ item.designRequest.code }}</span>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:[`item.designer`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.designer.avatar" :src="baseImage + item.designer.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.designer.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.designer.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:[`item.sendEmailStatus`]="{ item }">
        <span class="text-no-wrap linkText" v-if="item.sendEmailStatus === 1"> {{ $t('common.send_success') }} </span>
        <span class="text-no-wrap linkText" v-else-if="item.sendEmailStatus === 0"> {{ $t('common.send_fail') }} </span>
        <!-- <v-btn v-else color="primary" dark @click="resendCheckPriceEmail(item)">
          {{ $t('common.resend') }}
        </v-btn> -->
      </template>

      <template v-slot:[`item.createdAt`]="{ item }">
        <span class="text-no-wrap">{{ item.createdAt | formateDate }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <!-- <v-btn class="text-none" text @click="showDetail(item)">
          <span class="linkText text-no-wrap"> {{ $t('design_manager.detail') }} </span>
        </v-btn> -->
        <div class="contentTitle">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showDetail(item)">
                info
              </v-icon>
            </template>
            <span>Thông tin chi tiết</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="resendCheckPriceEmail(item)">
                refresh
              </v-icon>
            </template>
            <span>Gửi lại email check giá</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:[`item.designRequest.requestTitle`]="{ item }">
            <span class="contentTitle">
<!--              {{ item.designRequest.requestTitle + (item.designRequest.orderUnit ? (' - ' + item.designRequest.orderUnit.name) : '') }}-->
              {{ getManufactureTitle(item) }}
            </span>
      </template>

      <template v-slot:[`item.customer.fullname`]="{ item }">
              <span class="contentName">
                {{ item.customer.fullname }}
              </span>
      </template>

      <!-- <template v-slot:item.status="{ item }">
            {{ $t('manufacture_manager.processing') }}
      </template> -->

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <manufacture-request-dialog v-model="dialogDetail" :editedItem="editedItem" :editable="false" :isViewSale="true"
                                @closeDialog="closeDetail"
                                v-if="editedItem">
    </manufacture-request-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import ManufactureRequestDialog from "@/components/ManufactureRequestDialog";
import socketClient from "@/plugins/socketClient";

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    dateRange: {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()},
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    overlay: false,
    isSearching: false,

    isAdmin: localStorage.getItem('isAdmin') === 'true' ? true : false,
    userCategory: parseInt(localStorage.getItem('category')),
    userID: localStorage.getItem('user_id'),

    selectJobFilter: {},
    jobFilters: [
      {title: i18n.t('common.owner_job'), value: 0},
      {title: i18n.t('common.staff_job'), value: 1}
    ],

    selectReadStatus: {title: i18n.t('common.all'), value: -1},
    readStatus: [
      {title: i18n.t('common.unread'), value: 0},
      {title: i18n.t('common.read'), value: 1},
      {title: i18n.t('common.all'), value: -1}
    ],

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    personalJobs: [],
    staffJobs: [],

    search: '',
    dialog: false,
    dialogDetail: false,

    totalManufactureRequest: 0,

    headers: [],
    desserts: [],
    editedIndex: -1,
    editedItem: null,
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ],
  }),

  computed: {},

  components: {
    ManufactureRequestDialog: ManufactureRequestDialog
  },

  watch: {
    selectReadStatus() {
      this.filterData();
    },

    selectJobFilter() {
      if (this.selectJobFilter.value === 1) {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},

          {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname' },
          {text: i18n.t('design_manager.date'), value: 'createdAt'},

          {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
          {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},

          {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
          {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
          // { text: i18n.t('manufacture_manager.status'), value: 'status', sortable: false ,  width: '150px'},
          {text: i18n.t('common.status'), value: 'sendEmailStatus', sortable: false},
          {text: '', align: 'center', sortable: false, value: 'action'}
        ]
      } else {
        this.headers = [
          {text: '#', align: 'left', sortable: false, value: 'index',},
          {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
          {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
          {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
          // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname' },
          {text: i18n.t('design_manager.date'), value: 'createdAt'},
          {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
          {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
          // { text: i18n.t('manufacture_manager.status'), value: 'status', sortable: false ,  width: '150px'},
          {text: i18n.t('common.status'), value: 'sendEmailStatus', sortable: false},
          {text: '', align: 'center', sortable: false, value: 'action'}

        ]
      }

      this.filterData();
    }
  },

  created() {
    if (this.isAdmin) {
      this.headers = [
        {text: '#', align: 'left', sortable: false, value: 'index',},
        {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
        {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
        {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
        // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname' },
        {text: i18n.t('design_manager.date'), value: 'createdAt'},

        {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
        {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},

        {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
        {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
        {text: i18n.t('common.status'), value: 'sendEmailStatus', sortable: false},
        // { text: i18n.t('manufacture_manager.status'), value: 'status', sortable: false ,  width: '150px'},
        {text: '', align: 'center', sortable: false, value: 'action'}
      ]
    } else {
      this.selectJobFilter = this.jobFilters[0];
    }

    this.getData();
    this.isSearching = true;

    const self = this;
    socketClient.getIO().on('CREATE_MANUFACTURE_REQUEST', () => {
      self.getData();
    });

    socketClient.getIO().on('EDIT_CREATED_MANUFACTURE_REQUEST', () => {
      self.getData();
    });
  },

  methods: {
    initialize() {
    },

    getManufactureTitle(item) {
      return this.$getManufactureTitle(item);
    },

    createManufacture() {
      const agree = confirm(i18n.t('common.confirm_create_manufacture_bill'));
      if (!agree) {
        return;
      }

      this.$router.push({name: "createManufactureRequest", params: {createFromBill: true}});
    },

    showDetail(item) {
      console.log(item);

      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDetail = true;
    },

    closeDetail(value) {
      this.dialogDetail = value
      this.editedItem = null;
    },

    async getData() {
      const self = this;
      self.overlay = this.isSearching;
      try {
        // const response = await this.$http.get('/designRequest');
        const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");

        // const response = await this.$http.get('/manufactureRequest/by/me/status/1?' + "from=" + from + "&to=" + to);
        const response = await this.$http.get(process.env.VUE_APP_GET_MANUFACTURE_REQUEST_CONTEXT_API + "?status=1&from=" + from + "&to=" + to);
        self.overlay = false;
        if (response.data && response.data.success) {
          self.personalJobs = [];
          self.staffJobs = [];

          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);
          this.desserts = contextArr;

          this.desserts.forEach(item => {
            const saler = item.sale;
            if (saler && saler._id === self.userID) {
              self.personalJobs.push(item);
            } else {
              self.staffJobs.push(item);
            }
          })
          self.filterData();

          this.totalManufactureRequest = this.desserts.length;
          self.loading = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    filterData() {
      if (this.selectJobFilter && this.selectJobFilter.value === 0) {
        this.desserts = [].concat(this.personalJobs);
      } else {
        this.desserts = [].concat(this.staffJobs);
      }

      if (this.selectReadStatus.value !== -1) {
        this.desserts = [].concat(this.desserts.filter(item => item.saleReadStatus == this.selectReadStatus.value));
      }

      this.totalManufactureRequest = this.desserts.length;
    },

    addressToString(detail) {
      if (detail && detail.fullDetail) {
        return detail.fullDetail;
      } else {
        return '';
      }
    },

    async updateManufactureRequestInfor() {
      try {
        let imageIds = [];
        this.uploadedFiles.forEach(item => {
          imageIds.push(item.id);
        });

        const requestBody = {
          files: imageIds
        };
        console.log(requestBody);
        const response = await this.$http.put('/manufactureRequest/' + this.selectedManufactureRequest._id + '/files', requestBody);

        if (response.data && response.data.success) {
          Object.assign(this.desserts[this.editedIndex], this.selectedManufactureRequest);

          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {

          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async updateManufactureRequestStatus(item) {
      try {
        const requestBody = {
          status: 2
        }

        const response = await this.$http.put('/manufactureRequest/' + item._id + "/status", requestBody);

        if (response.data && response.data.success) {
          item.status = 1;
          Object.assign(this.desserts[this.editedIndex], this.item);

          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {

          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async resendCheckPriceEmail(request) {
      const agree = confirm(i18n.t('common.confirm_resend_email'));
      if (!agree) {
        return;
      }

      try {
        const response = await this.$http.get('/manufactureRequest/resendCheckPrice/' + request._id);
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.resend_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.getData();
          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },
  },
}
</script>